import { memo } from "react";

export const TariffCalculatorItem = memo(function TariffCalculatorItem() {
  // Hidden in production - routes remain functional for direct access
  return null;
});
